import {
  DrinkVariant,
  Drink,
} from 'services/api/entities/catalog/drink/types/internal/drink-models'
import { parseCsvFields } from 'services/utils/multilangParseWrite'
import { EntityDescriptor } from '.'
import { formatPriceRange } from './common'

const formatDrinkVariants = (variants: DrinkVariant[]) =>
  variants.map((v) => ({
    ...parseCsvFields({ Name: v.name }),
    pricing: v.pricing.map(formatPriceRange),
  }))

export const drinks: EntityDescriptor<Drink> = {
  format: () => (record) => ({
    ID: record.id,
    ...parseCsvFields({ Name: record.name, Description: record.description }),
    'With Multiple Variants': record.hasMultipleVariants,
    Variants: formatDrinkVariants(record.variants),
  }),
}
